import az from './locales/az.json';
import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import kk from './locales/kk.json';
import ky from './locales/ky.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';
import tr from './locales/tr.json';
import uz from './locales/uz.json';
import vi from './locales/vi.json';
import { ONBOARDING_STEPS, OnboardingAction, OnboardingStep } from './steps';

type OnboardingLocale = typeof ru;

export interface OnboardingCopy {
  controls: OnboardingLocale['controls'];
  requirements: Partial<Record<OnboardingAction, string>>;
  steps: readonly OnboardingStep[];
}

export const ONBOARDING_SUPPORTED_LANGUAGES = [
  'ru',
  'en',
  'vi',
  'es',
  'kk',
  'uz',
  'ky',
  'az',
  'pt',
  'fr',
  'tr',
  'de',
] as const;

export type OnboardingLanguage = typeof ONBOARDING_SUPPORTED_LANGUAGES[number];

const ONBOARDING_LOCALES: Record<OnboardingLanguage, OnboardingLocale> = {
  ru,
  en,
  vi,
  es,
  kk,
  uz,
  ky,
  az,
  pt,
  fr,
  tr,
  de,
};

const getOnboardingLocale = (language: string): OnboardingLocale =>
  ONBOARDING_LOCALES[language as OnboardingLanguage] ?? ru;

export const getOnboardingControls = (
  language: string
): OnboardingLocale['controls'] => getOnboardingLocale(language).controls;

export const getOnboardingCopy = (language: string): OnboardingCopy => {
  const locale = getOnboardingLocale(language);

  return {
    controls: locale.controls,
    requirements: locale.requirements,
    steps: ONBOARDING_STEPS.map((step) => {
      const text = locale.steps[step.id as keyof typeof locale.steps];

      return text ? { ...step, ...text } : step;
    }),
  };
};

export const formatOnboardingProgress = (
  template: string,
  current: number,
  total: number
): string =>
  template
    .replace('{current}', String(current))
    .replace('{total}', String(total));
